var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3333 52.5833C66.3333 52.5833 60.9167 51.75 56.3333 50.0833H55.0833C53.8333 50.0833 53 50.5 52.1667 51.3333L43 60.5C31.3333 54.25 21.3333 44.6667 15.5 33L24.6667 23.8333C25.9167 22.5833 26.3333 20.9167 25.5 19.6667C24.25 15.0833 23.4167 9.66667 23.4167 4.66667C23.4167 2.58333 21.3333 0.5 19.25 0.5H4.66667C2.58333 0.5 0.5 2.58333 0.5 4.66667C0.5 43.8333 32.1667 75.5 71.3333 75.5C73.4167 75.5 75.5 73.4167 75.5 71.3333V56.75C75.5 54.6667 73.4167 52.5833 71.3333 52.5833ZM8.83333 8.83333H15.0833C15.5 12.5833 16.3333 16.3333 17.1667 19.6667L12.1667 24.6667C10.5 19.6667 9.25 14.25 8.83333 8.83333ZM67.1667 67.1667C61.75 66.75 56.3333 65.5 51.3333 63.8333L56.3333 58.8333C59.6667 59.6667 63.4167 60.5 67.1667 60.5V67.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.88ff2e2b324d7ddffac5807a30786e78.svg";
export { ForwardRef as ReactComponent };